import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
    mainCol: {
        display: "flex",
        flexDirection: 'column',
        flexWrap: "nowrap",
        paddingTop: 5,
        paddingBottom: 8,
        marginBottom: 8
    },
    editableRow: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: 'center',
        marginTop: 0
    },
    row: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: 'center',
        marginTop: 7
    },
    col1: {
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 7,
    },
    col2: {        
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row'
    },
    editableTitle: {
        fontSize: 13,
        fontWeight: 700,
        paddingTop: 2,
    },
    title: {
        fontSize: 13,
        fontWeight: 700,
        color: 'gray'
    },
    text: {
        fontSize: 13,
        fontWeight: 500,
        color: 'gray'
    },
    switch: {
        "& .Mui-checked": {
            color: '#fff'
        },
        '&  .Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#69ABCF',
            color: '#69ABCF',
            opacity: 1
        },
    },
    mainContent: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 15,
        paddingBottom: 25,
        paddingLeft: 20,
        paddingRight: 20
    }
});